// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const rc: CountryValidator<"SK", ParsedPersonId> =
  createValidator("sk.rc", 162);

export default rc;
export const compact = rc.compact;
export const format = rc.format;
export const validate = rc.validate;
export const generate = (): string =>
  rc.generate?.() ??
  (() => {
    throw new Error(
      "Validator sk.rc cannot generate values",
    );
  })();
export const parse = rc.parse;
